import { CommonModule, DatePipe } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextAreaDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { Note } from '../../../../models/repEditorModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-log',
    templateUrl: './rep-editor-log.component.html',
    styleUrls: ['./rep-editor-log.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        CellTemplateDirective,
        EditTemplateDirective,
        DatePickerComponent,
        FormsModule,
        ReactiveFormsModule,
        DropDownListComponent,
        TextAreaDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorLogComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  notes: Note[]
  noteTypeList: any[]
  activeNoteTypeList = this.repState.getActiveNoteTypeList()
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repNotes) {
      this.initGrid()
    }

    if (!this.repState.noteTypeList) {
      this.typesService.getNoteTypes().subscribe((response) => {
        this.repState.noteTypeList = response
      })
    }
  }
  initGrid() {
    this.clientService
      .getNotesForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repNotes = response.map((note) => new Note(note))
      })
  }

  public addHandler({ sender }) {
    const newNote = new Note(null)
    newNote.rep = this.repId
    this.addHandlerShared({ sender }, newNote)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const note = new Note(formGroup.value)
    this.clientService.submitNoteUpdate(note).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  public createFormGroup(note: Note): UntypedFormGroup {
    return this.formBuilder.group({
      noteId: note.noteId,
      rep: note.rep,
      entryDate: [note.entryDate, Validators.required],
      noteTypeId: [note.noteTypeId, Validators.required],
      noteType: note.noteType,
      noteMemo: note.noteMemo,
      followup: note.followup,
    })
  }
}
